import { useLocation, useParams } from 'react-router-dom';

import LabsOverview from '../../features/labs/layouts/overview';
import LabDetail from '../../features/labs/layouts/detail';
import LabStats from '../../features/labs/layouts/stats';
import CreateLabForm from '../../features/labs/forms/create';
import EditLabForm from '../../features/labs/forms/edit';

// TSS vite/01 §"Pages are thin".
export default function LabsPage() {
    const { id } = useParams();
    const { pathname } = useLocation();

    if (pathname.endsWith('/new')) return <CreateLabForm />;
    if (id && pathname.endsWith('/edit')) return <EditLabForm labId={id} />;
    if (id && pathname.endsWith('/stats')) return <LabStats labId={id} />;
    if (id) return <LabDetail labId={id} />;
    return <LabsOverview />;
}
